import { formatActionType } from 'app/dealer/shared/higherOrderReducers/withDataRequest/actionTypeFormatters';

import { LISTINGS_BENCHMARK_REDUCER_NAME } from '../constants';

export const ListingsBenchmarkAuthStatusActionTypes = {
  RESET_LISTINGS_BENCHMARK_STATE: `[${formatActionType(
    LISTINGS_BENCHMARK_REDUCER_NAME,
  )} AuthStatus] RESET LISTINGS BENCHMARK STATE`,
  FULL_RESET_LISTINGS_BENCHMARK_STATE: `[${formatActionType(
    LISTINGS_BENCHMARK_REDUCER_NAME,
  )} AuthStatus] FULL RESET LISTINGS BENCHMARK STATE`,
  SAVE_PREVIOUSLY_SELECTED_DATE: `[${formatActionType(
    LISTINGS_BENCHMARK_REDUCER_NAME,
  )} AuthStatus] SAVE PREVIOUSLY SELECTED DATE`,
};
